const PDF = 'PDF';
const IMAGE = 'IMAGE';
const DOCUMENT = 'DOCUMENT';

const FILTERS = [PDF, IMAGE, DOCUMENT];

export { FILTERS, PDF, IMAGE, DOCUMENT };
